// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import {
  Button,
  Progress,
  Icon,
  Divider
} from 'semantic-ui-react'
import { storage } from '../firebase'
import WaveSurfer from 'wavesurfer.js'
import { CompactPicker } from 'react-color'
import { ReactMic } from 'react-mic'

class Home extends Component {
  constructor (props) {
    super(props)
    this.onStop = this.onStop.bind(this)
    this.state = {
      sound: null,
      url: '',
      progress: 0,
      uploaded: false,
      userBG: 'lightgrey',
      userWave: 'black',
      ready: true,
      waveModal: false,
      record: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
  }

  handleChange = e => {
    if (e.target.files[0]) {
      const sound = e.target.files[0]
      this.setState(() => ({ sound, selected: true, colors: true }))
    }
  }

  handleUpload = () => {
    this.setState({ uploading: true })
    const { sound } = this.state
    const uploadTask = storage.ref(`sounds/${sound.name}`).put(sound)
    uploadTask.on(
      'state_changed',
      snapshot => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        )
        this.setState({ progress })
      },
      error => {
        console.log(error)
      },
      () => {
        storage
          .ref('sounds')
          .child(sound.name)
          .getDownloadURL()
          .then(url => {
            let { userBG, userWave } = this.state
            console.log(url)
            this.props.history.push({
              pathname: '/build',
              state: {
                url: url,
                bg: userBG,
                wave: userWave
              }
            })
            this.setState(
              { url, uploaded: true, uploading: false },
              function () {
                console.log(url)
              }
            )
          })
      }
    )
  }

  mountWave () {
    const audio = document.querySelector('#song')
    this.wavesurfer = WaveSurfer.create({
      barWidth: 2,
      cursorWidth: 2,
      container: '#waveform',
      backend: 'MediaElement',
      height: 200,
      progressColor: 'red',
      responsive: true,
      waveColor: this.state.userWave,
      cursorColor: '#ddd',
      fillParent: true
    })
    this.wavesurfer.load(audio)
  }

  playTrack = () => {
    this.wavesurfer.playPause()
  }

  handleBG = color => {
    this.setState({ userBG: color.hex })
  }

  handleWave = color => {
    this.setState({ userWave: color.hex })
  }

  // Recording audio

  showRecording = () => {
    this.setState({
      showRecording: true
    })
  }

  startRecording = () => {
    this.setState({
      record: true
    })
  }

  stopRecording = () => {
    this.setState({
      record: false
    })
  }

  onStop (recordedBlob) {
    const self = this
    console.log(recordedBlob)
    // let newBlob = new Blob(recordedBlob, {type:'audio/mpeg-3'});
    self.setState({
      blobURL: recordedBlob.blobURL,
      recordedBlob: recordedBlob,
      previewRecording: true,
      colors: true
    })
  }

  previewRecording = () => {
    let { userBG, userWave } = this.state
    this.props.history.push({
      pathname: '/build',
      state: {
        bg: userBG,
        wave: userWave,
        recordedBlob: this.state.blobURL
      }
    })
  }
  onData () {
    console.log('recording')
  }

  render () {
    let {
      uploading,
      selected,
      userBG,
      userWave,
      sound,
      record,
      colors,
      previewRecording,
      showRecording
    } = this.state
    return (
      <div className='div1'>
        <div className='div3'>
          <h1>Monosfer</h1>
          <h4>Turn your favorite sound into digital art </h4>
        </div>
        <br />

        <div className='div3'>
          <h3>Try for free</h3>
          <br />
          {uploading && (
            <div>
              <Progress
                percent={this.state.progress}
                color='green'
                style={{ height: 10 }}
              >
                Uploading
              </Progress>
              <center>
                <p>Uploading ...</p>
              </center>
            </div>
          )}
          <input
            id='embedpollfileinput'
            class='inputfile'
            type='file'
            onChange={this.handleChange}
          />
          <label for='embedpollfileinput' class='ui black button'>
            <i class='ui upload icon' />
            Select a sound
          </label>
          <br />
          <Button
            style={{ marginTop: 25, marginBottom: 25 }}
            color='red'
            onClick={this.showRecording}
          >
            Record a sound
          </Button>
        </div>

        <br />

        {showRecording && (
          <div className='div3'>
            <h3>Microphone Recorder</h3>
            <ReactMic
              record={this.state.record}
              className='sound-wave'
              onStop={this.onStop}
              onData={this.onData}
              strokeColor='#111'
              backgroundColor='#fcfcfc'
            />
            <br />
            {record && !uploading ? (
              <Button color='red' circular onClick={this.stopRecording}>
                Stop
              </Button>
            ) : (
              <Button
                circular
                style={{ marginTop: 25, marginBottom: 25 }}
                color='red'
                onClick={this.startRecording}
              >
                <Icon name='circle' />
                Start
              </Button>
            )}
          </div>
        )}

        <br />

        {colors && !uploading && (
          <div className='div3'>
            <h3>Styling</h3>
            <Divider hidden/>
            <h5>Wave Color</h5>
            <CompactPicker
              id='picker'
              color={userWave}
              onChangeComplete={this.handleWave}
            />
            <h5>Background Color</h5>
            <CompactPicker
              id='picker'
              color={userBG}
              onChangeComplete={this.handleBG}
            />
          </div>
        )}

        {previewRecording && !uploading && (
          <div>
            <br />
            <div className='div3'>
              <Button
                onClick={this.previewRecording}
                color='black'
                size='large'
                circular
              >
                Preview Recording
              </Button>
            </div>
          </div>
        )}

        {selected && !uploading && (
          <div>
            <br />
            <div className='div3'>
              <Button
                onClick={this.handleUpload}
                color='black'
                size='large'
                circular
              >
                Preview {sound.name}
              </Button>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Home
